import {resource} from '@albert-io/json-api-framework/request/builder';
import type {QueryBuilder} from '@albert-io/json-api-framework/request/builder';

/**
 * The subset of user_v2 model accessors consumers of {@link getBaseUserQuery}
 * read off the resolved resource. Narrowed here once at the query boundary so
 * call sites don't each re-assert their own inline shape.
 */
export interface BaseUserResource {
  getUsername(): string;
  getFirstName(): string;
  getFullName(): string;
}

type BaseUserQuery = Omit<QueryBuilder, 'getResource'> & {
  getResource(): BaseUserResource;
};

/**
 * Takes a uuid and returns a query object for a user_v2 object of that ID
 *
 * @param {string} id
 */
export function getBaseUserQuery(id: string): BaseUserQuery {
  return resource('user_v2')
    .include('school_v5')
    .mandarkEndpoint(['users_v2', id])
    .withMeta('user_v2') as unknown as BaseUserQuery;
}
